<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-cascader
            v-model="currCategory"
            ref="cascader"
            clearable
            :options="categoryList"
            :props="{ checkStrictly: true, children: 'children', value: 'categoryId', label: 'name' }"
            @change="changeCategory"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="佣金排序">
          <el-select v-model="searchForm.commissionPriceSort">
            <el-option :value="0" label="无"></el-option>
            <el-option :value="1" label="从大到小"></el-option>
            <el-option :value="2" label="从小到大"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商">
          <div class="max-w460" @click="onSupplierChoose">
            <el-input style="width: 240px" readonly v-model="searchForm.supplierName"
                      placeholder="请选择供应商"></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="resetSearch">重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <!--    <div class="common-level-rail">-->
    <!--      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">-->
    <!--        添加产品-->
    <!--      </el-button>-->
    <!--    </div>-->

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="manufacturer" label="生产企业" width="240px"></el-table-column>
          <el-table-column prop="productBrand" label="品牌" width="120px"></el-table-column>
          <el-table-column prop="spec" label="规格" width="120px">
            <template slot-scope="scope">
              {{ getSpecName(scope.row.sku) }}
            </template>
          </el-table-column>

          <el-table-column prop="highSaleCommission" label="销售佣金" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              {{ scope.row.minSaleCommission }} <span
              v-if=" scope.row.highSaleCommission &&  (scope.row.highSaleCommission !== scope.row.minSaleCommission)">- {{
                scope.row.highSaleCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highTechnicalCommission" show-overflow-tooltip label="技术补贴" width="120px">
            <template slot-scope="scope">
              {{ scope.row.minTechnicalCommission }} <span
              v-if=" scope.row.highTechnicalCommission &&  (scope.row.highTechnicalCommission !== scope.row.minTechnicalCommission)">- {{
                scope.row.highTechnicalCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highPlatCommission" show-overflow-tooltip label="平台补贴" width="120px">
            <template slot-scope="scope">
              {{ scope.row.minPlatCommission }} <span
              v-if=" scope.row.highPlatCommission &&  (scope.row.highPlatCommission !== scope.row.minPlatCommission)">- {{
                scope.row.highPlatCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salesActual" label="实际销量" width="100px"></el-table-column>
          <!--                    <el-table-column label="商品属性">-->
          <!--                      <template slot-scope="scope">-->
          <!--                        <span v-if="scope.row.isVirtual == 0">实物商品</span>-->
          <!--                        <span v-if="scope.row.isVirtual == 1" class="green">虚拟商品</span>-->
          <!--                      </template>-->
          <!--                    </el-table-column>-->
          <el-table-column prop="createTime" label="发布时间" width="160px"></el-table-column>
          <!--          <el-table-column prop="productSort" label="排序"></el-table-column>-->
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <supplier-choose ref="supplierChoose" :storeType="20" @closeDialog="supplierChooseOk"/>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import SupplierChoose from '../../supplier/supplier/dialog/SupplierChoose'

export default {
  components: {
    SupplierChoose
  },
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: '',
        shopSupplierId: '',
        supplierName: '',
        commissionPriceSort: 0
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
      open_product: false,
      chooseType: 0,
      /*当前选中的*/
      currCategory: [],
    }
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    changeCategory (e) {
      let item = this.$refs['cascader'].getCheckedNodes()
      if (item && item.length) {
        this.searchForm.categoryId = item[0].data.categoryId
      } else {
        this.searchForm.categoryId = ''
      }
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      self.loading = true
      Params.isEnableCommission = 1
      Params.isChoose = 0
      PorductApi.squareLists(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.totalDataNumber = res.data.productList.total
          self.productCount = res.data.productCount
          self.supplierStatus = res.data.supplierStatus
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    resetSearch () {
      this.searchForm = {
        productName: '',
        categoryId: '',
        shopSupplierId: '',
        supplierName: '',
        commissionPriceSort: 0
      }
      this.curPage = 1
      this.currCategory = []
      this.getData()
    },
    /*打开添加*/
    addClick () {
      this.$router.push('/product/product/add')
    },

    /*打开编辑*/
    editClick (row) {
      console.log(row)
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'edit'
        }
      })
    },

    linkClick: function (val) {
      let self = this
      let copyText = 'pages/product/detail/detail?productId=' + val
      self.$copyText(copyText).then(function (e) {
        self.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function (e) {
        self.$message({
          showClose: true,
          message: '复制失败',
          type: 'error'
        })
      })
    },
    /*打开复制*/
    copyClick (row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'copy'
        }
      })
    },
    /*删除*/
    delClick: function (row) {
      let self = this
      let msg = ''
      msg = '删除后将不再分销该产品，确定删除该产品吗?'

      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.supplierDeleteConsignmentProduct({
            productIds: [row.productId]
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    /*修改状态*/
    changeStatus (item, value) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
        if (self.activeName == 'recovery') {
          msg = '确认要移动该商品到仓库吗?'
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      })
        .then(() => {
          PorductApi.changeStatus({
            productId: item.productId,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },

    /*打开弹出层*/
    selectProductClick () {
      this.open_product = true
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        // this.userInfo = e.params[0];
        // this.form.supplier.userId = e.params[0].userId;
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          productIds: productIds
        }
        PorductApi.addSupplierProduct(params).then(res => {

          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    },
    getSpecName (list) {
      let text = ''
      if (list && list.length) {
        let resultList = list.filter(res => res.specName)
        if (resultList && resultList.length) {
          text = resultList[0].specName
        }
      }
      return text
    },
    addSupplerProductClick (row) {
      let self = this
      let productIds = [row.productId]
      let params = {
        productIds: productIds
      }
      PorductApi.addSupplierProduct(params).then(res => {

        self.$message({
          message: '添加成功',
          type: 'success'
        })
        self.getData()
      }).catch(err => {
        self.$message({
          message: err.msg || '添加失败',
          type: 'error'
        })
      })
    },
    onSupplierChoose () {
      this.chooseType = 1
      this.$refs.supplierChoose.show()
    },
    supplierChooseOk (e) {
      if (e.type === 'success') {
        if (this.chooseType === 1) {
          this.searchForm.shopSupplierId = e.params.shopSupplierId || ''
          this.searchForm.supplierName = e.params.name || ''
        }
      }
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/consignmentindex.vue